import dayjs from "dayjs";

/** Shared Excel date format for import/export defaults. */
export enum ExcelDateFormat {
  IsoDate = "YYYY-MM-DD",
}

/** Default start date: today (ISO date). */
export const EXCEL_DEFAULT_START_DATE = dayjs().format(ExcelDateFormat.IsoDate);

/** Default end date: today (ISO date). */
export const EXCEL_DEFAULT_END_DATE = dayjs().format(ExcelDateFormat.IsoDate);

/** Default end date: today + 3 years (ISO date). */
export const EXCEL_DEFAULT_END_DATE_PLUS_3_YEARS = dayjs()
  .add(3, "year")
  .format(ExcelDateFormat.IsoDate);
